import { useTranslation } from 'react-i18next';

import { Placeholder } from './PlaceHolder';

const MovingConditionPlaceholder = (props: any) => {
  const { t } = useTranslation();

  return (
    <Placeholder
      placeholderText={t('You cannot add Unmerged Conditions to a loop.')}
      {...props}
    />
  );
};

export default MovingConditionPlaceholder;
